/* eslint-disable no-undef */
/* eslint-disable camelcase */
/* eslint-disable no-magic-numbers */
import React, { useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";
import { sendCustomGaEvents } from "../../../tracking";
import { InView } from "react-intersection-observer";
import styles from "./styles.css";
import LazyImage from "../lazy-image";
import { getDeviceType } from "../../../utils/helpers/device-type";
import FallbackDesktop from "./images/cars24970x90.png";
import FallbackMobile from "./images/cars24300x100.png";
import Loader_160_600 from "./images/160-600.gif";
import Loader_300_250 from "./images/300-250.gif";
import Loader_320_100 from "./images/320-100.gif";
import Loader_970_90 from "./images/970-90.gif";
import { yieldToMain } from "../../../utils/helpers/yield-to-main";

const LOADER_MAP = {
    LOADER_160_600: Loader_160_600,
    LOADER_300_250: Loader_300_250,
    LOADER_320_100: Loader_320_100,
    LOADER_970_90: Loader_970_90
};

const extractInlineScript = (html) => {
    const scriptRegex = /<script[^>]*>([\s\S]*?)<\/script>/gi;
    let match;
    let inlineScriptContent = "";

    while ((match = scriptRegex.exec(html)) !== null) {
        if (!match[0].includes("src=")) {
            inlineScriptContent += match[1];
        }
    }

    return inlineScriptContent;
};
const AdsComponent = ({
    fetchAdsDetailsConnect,
    pageType,
    platformType,
    url,
    slotName,
    bu,
    height = 90,
    width = "auto"
}) => {
    const [adsData, setAdsData] = useState({});
    const [loading, setIsLoading] = useState(false);
    const { adSlots = {}, adType = "", campId = "" } = adsData;
    const visibilityReported = useRef(false);
    const [inlineScriptContent, setInLineScriptContent] = useState("");
    const LoaderComponent = LOADER_MAP[`LOADER_${width}_${height}`];

    useEffect(() => {
        if (slotName && pageType) {
            sendCustomGaEvents({
                eventLabel: `${slotName}`,
                eventName: "ad_slot_load",
                eventAction: "ad_slot_loaded",
                eventCategory: pageType
            });
        }
    }, [slotName, pageType]);

    const handleVisibilityChange = async (inView) => {
        if (inView && !visibilityReported.current) {
            visibilityReported.current = true;
            await yieldToMain();
            sendCustomGaEvents({
                eventLabel: `${campId}|${slotName}|${adType}`,
                eventName: "ad_viewed",
                eventAction: "ad_viewed",
                eventCategory: pageType
            });
        }
    };

    const handleBannerClick = async () => {
        await yieldToMain();
        sendCustomGaEvents({
            eventLabel: `${campId}|${slotName}|${adType}`,
            eventName: "ad_clicked",
            eventAction: "ad_clicked",
            eventCategory: pageType
        });
    };

    useEffect(() => {
        return () => {
            if (window?.googletag?.cmd) {
                window.googletag.cmd.push(() => {
                    // Get all slots
                    const slots = window.googletag.pubads().getSlots();
                    slots.forEach((slot) => {
                        const slotId = slot.getSlotElementId();
                        // Check if slot ID matches the pattern and destroy it
                        if (slotId.startsWith("div-ad-gpt-")) {
                            window.googletag.destroySlots([slot]); // Destroy the slot
                            const div = document.getElementById(slotId);
                            if (div) {
                                div.remove(); // Remove the div element
                            }
                        }
                    });
                });
            }
        };
    }, []);

    useEffect(() => {
        const asyncScript = document.createElement("script");
        asyncScript.src = "https://securepubads.g.doubleclick.net/tag/js/gpt.js";
        asyncScript.async = true;
        document.body.appendChild(asyncScript);

        asyncScript.onload = () => {
            const inlineScript = document.createElement("script");
            inlineScript.innerHTML = inlineScriptContent;
            document.body.appendChild(inlineScript);
        };

        return () => {
            document.body.removeChild(asyncScript);
        };
    }, [inlineScriptContent]);

    const renderAdSlot = () => {
        const handleRedirection = () => {
            if (adSlots?.redirectionUrl) {
                window.open(adSlots.redirectionUrl, "_blank");
            }
        };

        if (adType === "network") {
            const htmlContent = adSlots.content;
            setInLineScriptContent(extractInlineScript(htmlContent));
            return (
                <div dangerouslySetInnerHTML={{ __html: htmlContent }} />
            );
        } else if (adType === "direct") {
            return (
                <LazyImage src={adSlots?.media.url} alt={adSlots?.media.alternativeText} onClick={handleRedirection} />
            );
        } else {
            return (
                <>
                    { getDeviceType().type === "Mobile" ?
                        <img src={FallbackDesktop} alt="Mobile Fallback" style={{ height, width}} styleName="styles.fallbackImage" />
                        :
                        <img src={FallbackMobile} alt="Desktop Fallback" style={{ height, width}} styleName="styles.fallbackImage" />
                    }
                </>
            );
        }
    };

    useEffect(() => {
        setIsLoading(true);
        window.setTimeout(() => {
            fetchAdsDetailsConnect({
                platformType,
                url,
                slotName,
                bu,
                expand: "YES"
            }).then((data) => {
                const adData = data?.adData[0][0] || {};
                setAdsData(adData);
                sendCustomGaEvents({
                    eventLabel: `${adData.campId}|${slotName}|${adType}`,
                    eventName: "ad_impression",
                    eventAction: "ad_impression",
                    eventCategory: pageType
                });
            }).catch(() => {
                setAdsData({ adSlots: {}, adType: "fallback" });
            }).finally(() => {
                setIsLoading(false);
            });
        }, 3000);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return (
        <>
            {loading ?
                <>
                    {LoaderComponent && <img src={LoaderComponent} alt="laoder" style={{ width, height}} styleName="styles.fallbackImage" />}
                </>
                :
                <InView as="div" threshold={0.5} onChange={
                    (inView) => handleVisibilityChange(inView)}>
                    {({ ref }) => (
                        <div className="shrinkOnTouch" styleName="styles.adsContainer" style={{ height }} onClick={() => handleBannerClick()} ref={ref}>
                            {renderAdSlot(adsData)}
                        </div>
                    )}
                </InView>
            }
        </>
    );
};

AdsComponent.propTypes = {
    shouldLoaderMobileLoader: PropTypes.bool,
    fetchAdsDetailsConnect: PropTypes.func,
    adsDetails: PropTypes.object,
    platformType: PropTypes.string,
    url: PropTypes.string,
    slotName: PropTypes.string,
    bu: PropTypes.string,
    expand: PropTypes.string,
    width: PropTypes.number,
    height: PropTypes.number,
    pageType: PropTypes.string
};

export default React.memo(AdsComponent);
